import React from 'react'
import styled from 'styled-components'
import { useTranslation, Trans } from 'react-i18next'
import { breakPoints, mainColors } from '../../../constants/constants'
import Page from '../../views/Page'
import { Col } from 'react-bootstrap'

import treeStructure from '../../../assets/home/tree-structure.svg'
import fileSearch from '../../../assets/home/file-search.svg'
import projectorScreenChart from '../../../assets/home/projector-screen-chart.svg'
import analytics from '../../../assets/home/analytics-icon.svg'

const data = [
  {
    title: "badge_1.title",
    subtitle: "badge_1.subtitle"
  },
  {
    title: "badge_2.title",
    subtitle: "badge_2.subtitle"
  },
  {
    title: "badge_3.title",
    subtitle: "badge_3.subtitle"
  },
]

const StyledSection = styled.section`
  background: ${mainColors.lightBlue};
  padding-top: 70px;
  padding-bottom: 70px;

  @media (max-width: ${breakPoints.sm}) {
    padding-top: 12%;
    padding-bottom: 12%;
  }
`

const TitleCol = styled(Col)`
  text-align: center;
  padding-bottom: 80px;

  h2 {
    font-weight: bold;
    font-size: 44px;
    line-height: 56px;
    color: ${mainColors.lighterGray};
    text-transform: uppercase;
    text-align: left;
    margin-top: 20px;

    @media (max-width: ${breakPoints.sm}) {
      text-align: center;
      margin-top: 0;
    }
  }
`

const WrapperCol = styled(Col)`
  display: flex;
  justify-content: space-between;
  padding-left: 125px;
  padding-right: 50px;
  position: relative;

  @media (max-width: ${breakPoints.sm}) {
    flex-direction: column;
    padding-left: 12px;
    padding-right: 12px;
  }
`

const Badge = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 5px;
  z-index: 1;

  span {
    display: block;
    text-align: center;
    max-width: 200px;
    width: 100%;
    text-align: left;

    @media (max-width: ${breakPoints.sm}) {
      text-align: center;
    }

    &:first-child {
      font-weight: 500;
      font-size: 24px;
      color: ${mainColors.lighterGray};
      padding-top: 26px;
      padding-bottom: 16px;
      line-height: 1;
      text-transform: uppercase;
    }
    &:last-child {
      font-weight: 400;
      font-size: 15px;
      line-height: 20px;
      color: #000;
    }
  }

  @media (max-width: ${breakPoints.sm}) {
    align-items: center;
  }
`

const Icon = styled.div`
  width: 95px;
  height: 95px;
  background: ${mainColors.darkBlue};
  border-radius: 50px;
  font-weight: bold;
  font-size: 48px;
  line-height: 20px;

  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  letter-spacing: 0.2px;
  color: ${mainColors.white};
`

const Principles = () => {
  const { t } = useTranslation()

  const badges = (data) => (
    data.map((item, index) => (
      <Badge key={index}>
        <Icon>{index + 1}.</Icon>
        <div>
          <span>{t('about_us.principles.badges.'+item.title)}</span>
          <span>{t('about_us.principles.badges.'+item.subtitle)}</span>
        </div>
      </Badge>
    ))
  )

  return (
    <StyledSection>
      <Page>
        <TitleCol md={3} sm={12}>
          <h2>{t('about_us.principles.title')}</h2>
        </TitleCol>
        <WrapperCol md={9} sm={12}>
          {badges(data)}
        </WrapperCol>
      </Page>
    </StyledSection>
  )
}

export default Principles
